import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';


import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';

import moment from 'moment';


import { Calendar } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import * as locales from "react-date-range/dist/locale";
import { DOMAINS } from '../../constants';
import MonthPicker from './components/monthPicker';

function getMaxDaysInCurrentMonth(value) {
    const currentDate = new Date(value);
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth(); // trenutni mesec

    // Postavlja datum na poslednji dan trenutnog meseca
    const date = new Date(year, month + 1, 0);
    return date.getDate(); // Vraća broj dana u tom mesecu
}
// function formatDateAndGetWeek(dateStr, lang) {
//     // Helper function to get the week number
//     function getWeekNumber(date) {
//         if (date && date !== NaN) {
//             date = new Date(date);
//             date.setHours(12, 0, 0, 0);
//             date.setDate(date.getDate() - 1);
//             const m = moment(date);
//             const week = m.week();
//             return week;
//         } else {
//             return null;
//         }
//     }

//     let date;
//     // Try parsing MM/DD/YYYY
//     if (dateStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
//         const [month, day, year] = dateStr.split("/");
//         date = new Date(`${year}-${month}-${day}`);
//     }
//     // Try parsing MM-DD-YYYY
//     else if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
//         const [month, day, year] = dateStr.split("-");
//         date = new Date(`${year}-${month}-${day}`);
//     }
//     // Try parsing YYYY-MM-DD
//     else if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
//         date = new Date(dateStr);
//     } else {
//         throw new Error("Invalid date format. Use MM-DD-YYYY or YYYY-MM-DD.");
//     }

//     if (isNaN(date.getTime())) {
//         throw new Error("Invalid date.");
//     }

//     // Format the date
//     const options = { weekday: "long", month: "short", day: "numeric" };
//     const locale = lang === 'se' ? 'sv-SE' : 'en-US';
//     const formattedDate = date.toLocaleDateString(locale, options);

//     // Get the week number
//     const weekNumber = getWeekNumber(date);

//     return {
//         formattedDate,
//         weekNumber: `${'v.'.translate(lang)} ${weekNumber}`
//     };
// }
function formatDateAndGetWeek(dateStr, lang) {
    if (!dateStr) return { formattedDate: null, weekNumber: null };

    // strict parsiranje, lokalno vrijeme (ne UTC)
    const m = moment(dateStr, ['MM/DD/YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'], true);
    if (!m.isValid()) return { formattedDate: null, weekNumber: null };

    const date = m.toDate();
    const options = { weekday: "long", month: "short", day: "numeric" };
    const locale = lang === 'se' ? 'sv-SE' : 'en-US';

    return {
        formattedDate: date.toLocaleDateString(locale, options),
        weekNumber: `${'v.'.translate(lang)} ${m.isoWeek()}`
    };
}
class OccupancyDateNavigation extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.state = {

        }
    }

    setInitialData = () => {
        const todayDate = new Date().setHours(12, 0, 0, 0);
        let today = moment(todayDate).format('MM/DD/YYYY');
        this.setState({ today });
    }



    componentDidMount() {
        this.setInitialData();

        document.addEventListener("mousedown", this.handleClickOutside);

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.showCalendar && prevState.showCalendar != this.state.showCalendar) {
            this.calculateWeekNumbersCalendar();
        }

    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                showCalendar: null,
            });
        }
    };
    clearCustomElements = () => {
        if (typeof window === 'undefined') return;
        let elementsForRemove = document.getElementsByClassName("rdrWeekDayWeekNumberLabel");
        while (elementsForRemove.length > 0) {
            elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
        }
        elementsForRemove = document.getElementsByClassName("rdrWeekNumber");
        while (elementsForRemove.length > 0) {
            elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
        }
    }
    calculateWeekNumberByDate = (dateStr) => {
        // if (dateStr && dateStr !== NaN) {
        //     let date = new Date(dateStr);
        //     date.setHours(12, 0, 0, 0);
        //     date.setDate(date.getDate() - 1);
        //     const m = moment(date);
        //     const week = m.week();
        //     return week && week !== NaN ? week : null;
        // } else {
        //     return null;
        // }
        if (!dateStr) return null;

        const m = moment(dateStr, 'MM/DD/YYYY', true);
        if (!m.isValid()) return null;

        return m.isoWeek();
    }

    calculateWeekNumbersCalendar = (number = 0) => {
        if (this.state.showCalendar) {
            if (typeof window === 'undefined') return;

            this.clearCustomElements();

            const weekDays = document.getElementsByClassName("rdrWeekDays");
            const days = document.getElementsByClassName("rdrDays");
            const newArray = days?.[0]?.children ?? [];

            if (this.dateArr?.length === newArray.length && newArray.length > 0) {
                if (weekDays) {
                    for (let i = 0; i < weekDays.length; i++) {
                        let weekNumber = document.createElement("span");
                        weekNumber.className = "rdrWeekDayWeekNumberLabel";
                        weekNumber.innerHTML = `v`.translate(this.props.lang);
                        weekDays[i].insertBefore(weekNumber, weekDays[i].childNodes[0]);
                    }
                    let rdrWeekDay = document.getElementsByClassName("rdrWeekDay");
                    for (let i = 0; i < rdrWeekDay?.length; i++) {
                        rdrWeekDay[i]?.style?.setProperty("flex-basis", "calc(100% / 8)", "important");
                    }
                }

                // if (newArray.length > 0) {

                //     for (let i = 0; i < newArray.length; i++) {
                //         if (i === 0 || i % 8 === 0) {
                //             let element = document.createElement("div");
                //             element.className = "rdrWeekNumber";
                //             element.innerHTML = this.calculateWeekNumberByDate(this.dateArr[i]) ?? '';
                //             days?.[0]?.insertBefore?.(element, newArray[i]);
                //         }
                //     }
                //     let rdrDay = document.getElementsByClassName("rdrDay");
                //     for (let i = 0; i < rdrDay?.length; i++) {
                //         rdrDay[i]?.style?.setProperty("width", "calc(100% / 8)", "important");
                //     }
                // }
                if (newArray.length > 0) {
                    const dayCells = Array.from(newArray);
                    const rows = Math.ceil(dayCells.length / 7);

                    for (let row = 0; row < rows; row++) {
                        const firstDayIndex = row * 7;
                        const element = document.createElement("div");
                        element.className = "rdrWeekNumber";
                        element.innerHTML = this.calculateWeekNumberByDate(this.dateArr[firstDayIndex]) ?? '';
                        days?.[0]?.insertBefore?.(element, dayCells[firstDayIndex]);
                    }

                    let rdrDay = document.getElementsByClassName("rdrDay");
                    for (let i = 0; i < rdrDay?.length; i++) {
                        rdrDay[i]?.style?.setProperty("width", "calc(100% / 8)", "important");
                    }
                }
            } else {
                if (number > 10) return;
                setTimeout(() => {
                    this.calculateWeekNumbersCalendar(number + 1);
                }, 20 * number + 10);
            }
        }
    }

    onPreviousClick = () => {
        const date = this.props.date;
        const view = this.props.view;

        let newDate = new Date(`${date} 12:00`);
        if (view === 'month') {
            newDate.setMonth(newDate.getMonth() - 1);
        } else if (view === 'week' || view === 'work-week') {
            newDate.setDate(newDate.getDate() - 7);
        } else if (view === 'day') {
            newDate.setDate(newDate.getDate() - 1);
        }
        let newDateStr = moment(newDate).format('MM/DD/YYYY');
        if (this.props.onChange) {
            this.props.onChange(newDateStr);
        }
    }
    onNextClick = () => {
        const date = this.props.date;
        const view = this.props.view;

        let newDate = new Date(`${date} 12:00`);
        if (view === 'month') {
            newDate.setMonth(newDate.getMonth() + 1);
        } else if (view === 'week' || view === 'work-week') {
            newDate.setDate(newDate.getDate() + 7);
        } else if (view === 'day') {
            newDate.setDate(newDate.getDate() + 1);
        }

        let newDateStr = moment(newDate).format('MM/DD/YYYY');
        if (this.props.onChange) {
            this.props.onChange(newDateStr);
        }
    }
    onClickToday = () => {
        let today = this.state.today;
        if (!today) {
            let date = new Date().setHours(12, 0, 0, 0);
            today = moment(date).format('MM/DD/YYYY');
        }
        if (this.props.onChange && today) {
            this.props.onChange(today);
        }
    }

    getLocale = () => {
        let locale = null;
        if (typeof window !== "undefined" && window._lang) {
            if (window._lang == "en") {
                locale = locales.enGB;
            } else {
                let domen = window.location.origin;
                let country = DOMAINS.find((item) => item.domen == domen)?.country;
                if (country == "sweden") {
                    locale = locales.sv;
                } else if (country == "denmark") {
                    locale = locales.da;
                } else if (country == "gr") {
                    locale = locales.el;
                } else if (country == "es") {
                    locale = locales.es;
                } else if (country == "ch") {
                    locale = locales.de;
                } else {
                    locale = locales.enGB;
                }
            }
        }
        return locale;
    }
    toggleCalendar = () => {
        if (!this.state.showCalendar) {
            this.dateArr = [];
        }
        this.setState({
            showCalendar: !this.state.showCalendar
        });
    }
    getNavigationDate = (days) => {
        if (!days?.length) return null;
        const view = this.props.view;
        const lang = this.props.lang;

        if (view === 'day' && days?.[0]?.dateString) {
            let dateString = days?.[0]?.dateString;
            const [month, day, year] = dateString.split('/').map(Number);
            const date = new Date(year, month - 1, day);
            const dayOfWeek = date.getDay();
            const dayOfWeekString = [
                'Sunday'.translate(lang),
                'Monday'.translate(lang),
                'Tuesday'.translate(lang),
                'Wednesday'.translate(lang),
                'Thursday'.translate(lang),
                'Friday'.translate(lang),
                'Saturday'.translate(lang)
            ];

            const monthString = [
                'Jan'.translate(lang),
                'Feb'.translate(lang),
                'Mar'.translate(lang),
                'Apr'.translate(lang),
                'May'.translate(lang),
                'Jun'.translate(lang),
                'Jul'.translate(lang),
                'Aug'.translate(lang),
                'Sep'.translate(lang),
                'Oct'.translate(lang),
                'Nov'.translate(lang),
                'Dec'.translate(lang)
            ];
            return `${dayOfWeekString[dayOfWeek]} ${monthString?.[month - 1]} ${String(date.getDate()).padStart(2, '0')}`
        } else if ((view === 'week' || view === 'work-week') && days?.length) {
            let startDate = days?.[0]?.dateString;
            let endDate = days?.[days.length - 1]?.dateString;
            const [startMonth, startDay, startYear] = startDate.split('/').map(Number);
            const [endMonth, endDay, endYear] = endDate.split('/').map(Number);
            const _startDay = new Date(startYear, startMonth - 1, startDay);
            const _endDay = new Date(endYear, endMonth - 1, endDay);

            const shortMonthString = [
                'Jan'.translate(lang),
                'Feb'.translate(lang),
                'Mar'.translate(lang),
                'Apr'.translate(lang),
                'May'.translate(lang),
                'Jun'.translate(lang),
                'Jul'.translate(lang),
                'Aug'.translate(lang),
                'Sep'.translate(lang),
                'Oct'.translate(lang),
                'Nov'.translate(lang),
                'Dec'.translate(lang)
            ];
            const monthString = [
                'January'.translate(lang),
                'February'.translate(lang),
                'March'.translate(lang),
                'April'.translate(lang),
                'May'.translate(lang),
                'June'.translate(lang),
                'July'.translate(lang),
                'August'.translate(lang),
                'September'.translate(lang),
                'October'.translate(lang),
                'November'.translate(lang),
                'December'.translate(lang)
            ];
            const startMonthString = startMonth === endMonth ? monthString?.[startMonth - 1] : shortMonthString?.[startMonth - 1];
            const endMonthString = startMonth === endMonth ? monthString?.[endMonth - 1] : shortMonthString?.[endMonth - 1];

            if (startMonth === endMonth) {
                return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${String(_endDay.getDate()).padStart(2, '0')}`;
            } else {
                return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${endMonthString} ${String(_endDay.getDate()).padStart(2, '0')}`;
            }
        }
    }
    getWeekDates = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        let dayOfWeek = date.getDay();

        const monday = new Date(date);
        const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
        monday.setDate(date.getDate() + diff);

        const weekDates = Array.from({ length: 7 }, (_, i) => {
            const currentDate = new Date(monday);
            currentDate.setDate(monday.getDate() + i);

            return (
                String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
                String(currentDate.getDate()).padStart(2, '0') + '/' +
                currentDate.getFullYear()
            );
        });

        return weekDates;
    }
    getWorkWeekDates = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        let dayOfWeek = date.getDay();

        const monday = new Date(date);
        const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
        monday.setDate(date.getDate() + diff);

        const weekDates = Array.from({ length: 5 }, (_, i) => {
            const currentDate = new Date(monday);
            currentDate.setDate(monday.getDate() + i);

            return (
                String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
                String(currentDate.getDate()).padStart(2, '0') + '/' +
                currentDate.getFullYear()
            );
        });

        return weekDates;
    }
    generateDays = () => {
        const date = this.props.date;
        const view = this.props.view;
        let days = [];

        if (view === 'day') {
            days.push({
                dateString: date,
                isToday: date === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
            });

        } else if (view === 'week') {
            let weekDays = this.getWeekDates(date);
            if (!weekDays || weekDays?.length !== 7) return [];
            for (let i = 0; i < weekDays.length; i++) {
                days.push({
                    dateString: weekDays[i],
                    isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                });
            }
        } else if (view === 'work-week') {
            let weekDays = this.getWorkWeekDates(date);
            if (!weekDays || weekDays?.length !== 5) return [];
            for (let i = 0; i < weekDays.length; i++) {
                days.push({
                    dateString: weekDays[i],
                    isToday: weekDays[i] === this.props?.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
                });
            }
        }
        return days;
    }
    generateDateString = () => {
        const date = this.props.date;
        const view = this.props.view;


        if (view === 'month') {
            let month = moment(date).format('MMMM');
            let year = moment(date).format('YYYY');
            if (month && year) {
                return `${month?.translate(this.props.lang)} ${year}`;
            }
        } else if (view === 'week' || view === 'work-week') {
            let days = this.generateDays();
            let navigationDate = this.getNavigationDate(days);
            if (navigationDate) {
                return navigationDate;
            }
        } else if (view === 'day' && date?.split('/').length === 3) {
            const [month, day, year] = date.split('/').map(Number);
            const _date = new Date(year, month - 1, day);
            const dayOfWeek = _date.getDay();
            const lang = this.props.lang || 'se';
            const dayOfWeekString = [
                'Sunday'.translate(lang),
                'Monday'.translate(lang),
                'Tuesday'.translate(lang),
                'Wednesday'.translate(lang),
                'Thursday'.translate(lang),
                'Friday'.translate(lang),
                'Saturday'.translate(lang)
            ];

            const monthString = [
                'Jan'.translate(lang),
                'Feb'.translate(lang),
                'Mar'.translate(lang),
                'Apr'.translate(lang),
                'May'.translate(lang),
                'Jun'.translate(lang),
                'Jul'.translate(lang),
                'Aug'.translate(lang),
                'Sep'.translate(lang),
                'Oct'.translate(lang),
                'Nov'.translate(lang),
                'Dec'.translate(lang)
            ];
            return `${dayOfWeekString[dayOfWeek]} ${monthString?.[month - 1]} ${String(_date.getDate()).padStart(2, '0')}`
        }


        return date;
    }


    render() {
        const date = this.props.date;
        const view = this.props.view;

        const locale = this.getLocale();
        const calendarDate = this.props.date ? new Date(this.props.date?.replace(/-/g, "/")) : new Date();

        let { formattedDate, weekNumber } = formatDateAndGetWeek(this.props.date, this.props.lang)
        const isTodayDate = this.state.today && this.state.today === this.props.date ? true : false;
        if (view === 'month') {
            weekNumber = null;
        }

        const dateString = this.generateDateString();
        return (
            <div className='custom-calendar-date-navigation-wrap' ref={this.wrapperRef}>
                <Button
                    color='primary'
                    onClick={() => {
                        if (!isTodayDate)
                            this.onClickToday();
                    }}
                    className='custom-calendar-date-navigation-today-button'
                >
                    {'Today'.translate(this.props.lang)}
                </Button>
                <Button
                    color='primary'
                    onClick={() => this.onPreviousClick()}
                    className='custom-calendar-date-navigation-previous-button'
                >
                    {'Previous'.translate(this.props.lang)}
                </Button>
                <div className='custom-calendar-date-navigation-date' onClick={this.toggleCalendar}>
                    <div className="week-number">{weekNumber ? weekNumber : null}</div>
                    {dateString}
                    <div className="empty-div"></div>
                </div>
                <Button
                    color='primary'
                    onClick={() => this.onNextClick()}
                    className='custom-calendar-date-navigation-next-button'
                >
                    {'Next'.translate(this.props.lang)}
                </Button>


                {this.state.showCalendar ? (
                    <div className="calendar-date-picker-wrap">
                        {/* <div className="calendar-date-picker-today-wrap">
                            <div
                                className={isTodayDate ? 'calendar-date-picker-today calendar-date-picker-today-disabled' : 'calendar-date-picker-today'}
                                onClick={() => {
                                    if (!isTodayDate)
                                        this.onClickToday();
                                }}
                            >
                                {'Go to today'.translate(this.props.lang)}
                            </div>
                        </div> */}
                        {
                            this.props.view === 'month' ?
                                <MonthPicker
                                    {...this.props}
                                    date={date}
                                    onChange={(date, close = false) => {
                                        if (!date) return;
                                        if (this.props.onChange) {
                                            this.props.onChange(date);
                                        }
                                        if (close) {
                                            this.setState({ showCalendar: null });
                                        }
                                    }}
                                />
                                :
                                <Calendar
                                    date={calendarDate}
                                    locale={locale}
                                    dayContentRenderer={(date) => {
                                        if (date) {
                                            let dateStr = moment.unix(new Date(date).getTime() / 1000).format('MM/DD/YYYY');
                                            let dateArr = this.dateArr?.length ? this.dateArr : [];
                                            if (!dateArr.includes(dateStr)) {
                                                dateArr.push(dateStr);
                                                this.dateArr = dateArr;
                                            }
                                        }
                                    }}

                                    onShownDateChange={(date) => {
                                        this.dateArr = [];
                                        this.calculateWeekNumbersCalendar();
                                        let d = new Date(date);
                                        if (this.props.date) {
                                            const daysInMonth = getMaxDaysInCurrentMonth(date);
                                            let currentDate = new Date(this.props.date.replace(/-/g, "/")).getDate();
                                            let dateValue = currentDate > daysInMonth ? daysInMonth : currentDate;
                                            d.setDate(dateValue);
                                        }

                                        this.props.onChange(moment(d).format("MM/DD/YYYY"));
                                    }}
                                    onChange={(date) => {
                                        if (!date) return;
                                        const selectedDate = moment(new Date(date)).format("MM/DD/YYYY");
                                        this.setState({ showCalendar: null }, () => {
                                            if (this.props.onChange) {
                                                this.props.onChange(selectedDate);
                                            }
                                        })
                                    }}
                                />
                        }

                    </div>
                ) : null}
            </div>


        )
    }
}

export default OccupancyDateNavigation;